import {openBackupSection} from './adapter';

/**
 * Backup.
 *
 * Deliberately thin, the way Canvas Settings is: two lists - Site Backup and
 * System Backup - live as their own accordions on the Backup tab of
 * Maintenance, and each owns its own section, resolver, filter, and modals.
 * This plugin owns only the tab-level section a generic "show backup"
 * lands on before either list is named, plus the `options` capability that
 * offers Site Backup and System Backup as follow-ups.
 */
const backupPlugin = {
	id: 'backup',
	version: 1,
	commandVersion: 1,
	resource: 'backup',
	operations: ['options'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.backup': openBackupSection,
	},
};

export default backupPlugin;
